var map = {
	"./1.jpeg": 5440,
	"./2.jpeg": 6721,
	"./3.jpeg": 6689,
	"./4.jpeg": 8292,
	"./5.jpeg": 4634,
	"./6.jpeg": 3203,
	"./7.jpeg": 4116,
	"./8.jpeg": 2575,
	"./9.jpeg": 2862
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7146;